module.exports = __webpack_public_path__ + "img/lady_2.9b7e45de.png";